import { useState } from 'react';
import clsx from 'clsx';
import { Icon } from '../../../layout/Icon.jsx';
import { useSuppliers, useCreateSupplier } from '../hooks/useSuppliers.js';

function CreateModal({ open, onClose, onCreated }) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const create = useCreateSupplier();

  if (!open) return null;

  async function submit() {
    if (!name.trim()) { setError('الاسم مطلوب'); return; }
    try {
      const body = { name: name.trim() };
      if (phone.trim()) body.phone = phone.trim();
      const res = await create.mutateAsync(body);
      onCreated?.(res);
      setName('');
      setPhone('');
      setError('');
    } catch (err) {
      setError(err?.response?.data?.error?.message || err.message);
    }
  }

  return (
    <div
      className="fixed inset-0 z-[60] grid place-items-center"
      style={{ background: 'rgba(0,0,0,.45)' }}
    >
      <div className="card w-[400px] max-w-full" onClick={(e) => e.stopPropagation()}>
        <div className="card-h">
          <h3 className="text-[15px] font-bold flex-1">مورد جديد</h3>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            <Icon name="x" size={14} />
          </button>
        </div>
        <div className="card-b space-y-3">
          <div>
            <label className="block text-xs font-semibold text-ink-2 mb-1">الاسم *</label>
            <input className="input" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div>
            <label className="block text-xs font-semibold text-ink-2 mb-1">الهاتف</label>
            <input
              className="input"
              dir="ltr"
              style={{ textAlign: 'right' }}
              placeholder="07xxxxxxxxx"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
          {error ? <div className="text-red text-[12px] font-semibold">{error}</div> : null}
        </div>
        <div className="card-h border-b-0 border-t flex justify-end gap-2">
          <button type="button" className="btn" onClick={onClose}>إلغاء</button>
          <button type="button" className="btn btn-primary" onClick={submit} disabled={create.isPending}>
            {create.isPending ? 'جاري...' : 'إنشاء'}
          </button>
        </div>
      </div>
    </div>
  );
}

export function SupplierPicker({ value, onChange, error, allowCreate = true }) {
  const { data } = useSuppliers();
  const suppliers = data?.items || [];
  const [createOpen, setCreateOpen] = useState(false);

  return (
    <>
      <div className="flex gap-1.5">
        <select
          className={clsx('input flex-1', error && 'border-red')}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value="">— اختر مورداً —</option>
          {suppliers.map((s) => (
            <option key={s._id || s.id} value={s._id || s.id}>{s.name}</option>
          ))}
        </select>
        {allowCreate ? (
          <button type="button" className="btn" onClick={() => setCreateOpen(true)} title="مورد جديد">
            <Icon name="plus" size={14} />
          </button>
        ) : null}
      </div>
      {error ? <div className="text-red text-[11.5px] mt-1 font-semibold">{error}</div> : null}
      <CreateModal
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        onCreated={(s) => {
          onChange(s._id || s.id);
          setCreateOpen(false);
        }}
      />
    </>
  );
}
